



































































import { Component, Vue } from 'vue-property-decorator'
import { CompanyInfoDto, getCompanyDtl, handleMerchantsApply } from "@/api/customerManage";

@Component({
  name: 'CustomerApplyHandle'
})
export default class CustomerApplyHandle extends Vue {
  companyId = ''
  merchantsId = ''
  applyId = ''
  applyMessage = ''
  companyInfo: CompanyInfoDto | Record<string, any> = {}
  serviceLineActive = ['1']

  created () {
    this.companyId = this.$route.query.companyId as string
    this.merchantsId = this.$route.query.merchantsId as string
    this.applyId = this.$route.query.applyId as string
    this.applyMessage = this.$route.query.msg as string
    this.getInfo()

  }

  getInfo () {
    getCompanyDtl({ companyId: this.merchantsId }).then(res => {
      this.companyInfo = res.data
    })
  }

  /**
   * 处理客户申请
   * @param type 2拒绝  1通过
   */
  applyHandle (type: number) {
    const params = {
      applyId: this.applyId,
      isPass: type,
      merchantsId: this.merchantsId
    }
    if (type === 2) {
      handleMerchantsApply(params).then(() => {
        this.$toast.success({
          message: `客户添加申请已拒绝`,
          duration: 1000,
          onClose: () => {
            this.$router.back()
          }
        })
      })
    } else {
      this.$router.push({
        path: '/applySetting',
        query: {
          merchantsId: this.merchantsId,
          companyId: this.companyId,
          applyId: this.applyId,
          companyCode: this.$route.query.companyCode,
        }
      })
    }
  }
}
